module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissions"
  }, [_c('div', {
    staticClass: "permissions__col"
  }, [_c('div', {
    staticClass: "permissions__col__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.roles')))])]), _vm._v(" "), _c('div', {
    staticClass: "permissions__col__body"
  }, [_c('ul', [(_vm.isLoadingRoles) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff",
      "size": "small"
    }
  }) : _vm._l((_vm.rolesWithMeta), function(role) {
    return _c('li', {
      key: role.id,
      staticClass: "permissions__roles__role",
      class: {
        'permissions__roles__role--is-active': _vm.isActiveRole(role)
      },
      on: {
        "click": function($event) {
          return _vm.setActiveRole(role)
        }
      }
    }, [_c('div', {
      staticClass: "role__left"
    }, [_c('p', [_vm._v(_vm._s(role.v_title))])]), _vm._v(" "), _c('div', {
      staticClass: "role__right"
    }, [_c('span', {
      staticClass: "role__number-of-user"
    }, [_c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n            " + _vm._s(role.user_ids.length) + "\n            ")]), _vm._v(" "), (role.name !== 'Administrator' && role.name !== 'Regular user' && role.name !== 'Read only user') ? _c('DDropdown', {
      staticClass: "role-dropdown"
    }, [_c('ul', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.setTheEditRole(role)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                ")]), _vm._v(" "), (role.user_ids.length > 0) ? _c('li', {
      staticClass: "d-item-warning d-item-warning--disabled hint--right",
      attrs: {
        "aria-label": _vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')
      }
    }, [_c('div', {
      staticClass: "d-item-warning--disabled__inner"
    }, [_c('span', {
      staticClass: "icon-bin"
    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (role.user_ids.length === 0) ? _c('li', {
      staticClass: "d-item-warning",
      on: {
        "click": function($event) {
          return _vm.setTheDeleteRole(role)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    }), _vm._v("\n                  " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                ")]) : _vm._e()])]) : _vm._e()], 1)])
  }), _vm._v(" "), (!_vm.isLoadingRoles) ? _c('li', {
    staticClass: "permissions__roles__role__create"
  }, [_c('button', {
    staticClass: "btn btn-trans",
    on: {
      "click": function($event) {
        return _vm.setIsRoleModal(true)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.permissions.create_new_role')) + "\n          ")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "permissions__col"
  }, [_c('div', {
    staticClass: "permissions__col__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.users')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeRole ? _vm.activeRole.v_title : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "permissions__col__body"
  }, [_c('div', {
    staticClass: "permissions__col__body__users"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('DSelect', {
    attrs: {
      "items": _vm.usersForDSelect,
      "itemsSelected": [],
      "placeholder": _vm.$t('vue2.common.add_user'),
      "showSelectedUsers": false
    },
    on: {
      "add": function($event) {
        return _vm.addUserToRole($event)
      }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "permissions__col__body__users__list"
  }, [_c('virtual-list', {
    staticStyle: {
      "height": "500px",
      "overflow-y": "auto"
    },
    attrs: {
      "estimate-size": 40,
      "keeps": 20,
      "data-key": 'id',
      "data-sources": _vm.usersWithActiveRole,
      "data-component": _vm.itemComponent,
      "extra-props": {
        selectableRoles: _vm.selectableRoles
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "permissions__col"
  }, [_c('div', {
    staticClass: "permissions__col__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.permissions.permissions')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeRole && _vm.activeRole.v_title))])])]), _vm._v(" "), _c('div', {
    staticClass: "permissions__col__body"
  }, [(_vm.getRoleDesc.length > 0) ? _c('p', {
    staticClass: "role__desc"
  }, [_vm._v(_vm._s(_vm.getRoleDesc))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "permissions__permissions"
  }, _vm._l((_vm.activePermissions), function(permission) {
    return _c('li', {
      key: permission.permission,
      staticClass: "permissions__permissions__permission",
      attrs: {
        "data-permission": permission.permission
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.togglePermissionToRole(permission.permission)
        }
      }
    }, [(_vm.getIsPermissioni18n(permission.permission)) ? _c('p', [_vm._v(_vm._s(_vm.getIsPermissioni18n(permission.permission)))]) : _c('p', [_vm._v(_vm._s(permission.vTitle))]), _vm._v(" "), _c('app-toggle', {
      attrs: {
        "propOn": _vm.isPermissionInActiveRole(permission.permission)
      }
    })], 1)
  }), 0)])]), _vm._v(" "), (_vm.isRoleModal) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "role-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "role-modal__header"
  }, [_c('h2', [(!_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.create_new_role')))]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && !_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.rename_role')))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.delete_role')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "role-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setIsRoleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "role-modal__body"
  }, [(!_vm.theDeleteRole) ? _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [(!_vm.theEditRole) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_role_a_title')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.permissions.choose_new_name')))])]), _vm._v(" "), _c('input', {
    ref: "roleCreateInputField",
    staticClass: "box-shadow bg-white animated",
    class: {
      'shake': _vm.isSavingWithoutInput
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.createNewRoleName
    },
    on: {
      "input": _vm.onInput
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteRole) ? _c('div', {
    staticClass: "d-group marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.select_role_to_base_new_on')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.existingRoleToCopyId),
      expression: "existingRoleToCopyId"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.existingRoleToCopyId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.rolesToCopy), function(role) {
    return _c('option', {
      key: role.id,
      domProps: {
        "value": role.id
      }
    }, [_vm._v("\n              " + _vm._s(role.v_title) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "\n            "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\"" + _vm._s(_vm.theDeleteRole.v_title) + "\"")]), _vm._v(" " + _vm._s(_vm.$t('vue2.permissions.role')) + " ?")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('div', {
    staticClass: "unable-to-delete-warning"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.you_cant_delete_a_role_that_has_users')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.permissions.give_the_following_user_a_new_role')))]), _vm._v(" "), _c('ul', {
    staticClass: "permissions__col__body__users__list"
  }, _vm._l((_vm.usersWithActiveRole), function(user) {
    return _c('li', {
      staticClass: "permissions__col__body__users__list__user"
    }, [_c('div', [_c('img', {
      attrs: {
        "src": user.default_thumb_url
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-buttons marg-10-top"
  }, [_c('button', {
    staticClass: "marg-5-right",
    on: {
      "click": function($event) {
        return _vm.setIsRoleModal(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theDeleteRole && !_vm.isInputFieldLength) ? _c('button', {
    staticClass: "submit-button bttn--disabled",
    on: {
      "click": _vm.onNoInput
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.createNewRole
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditRole && _vm.isInputFieldLength) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.updateRoleName
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.rename')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length < 1) ? _c('button', {
    staticClass: "bttn bttn-danger",
    on: {
      "click": _vm.deleteRole
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteRole && _vm.theDeleteRole.user_ids.length > 0) ? _c('button', {
    staticClass: "bttn bttn--danger bttn--disabled"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.isRoleModal) ? _c('div', {
    staticClass: "bg-overlay"
  }) : _vm._e(), _vm._v(" "), _c('PermissionsUserChange', {
    attrs: {
      "roles": _vm.selectableRoles
    },
    on: {
      "set": function($event) {
        return _vm.setRole($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44e94f52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Permissions/Permissions.vue
// module id = 1615
// module chunks = 1